import React,{useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import Routes from "../config/routes";
import E_Header from "./e_header/e_header";
import { makeStyles } from "@material-ui/core/styles";
import E_Footer from "./e_footer/e_footer";
import { useMediaQuery } from "react-responsive";
import E_SidebarController from "./e_sidebar/e_sidebar_controller";
import ErrorBoundary from "./e_error-bounder";
import { authService } from "../../services/auth.service";
import { routePaths } from "../config/route-paths";
import { accountsDetails } from "../../actions/home.action";

const useStyle = makeStyles((theme)=>({
  root: {
    display: "flex",
    flexDirection: "column",
    zIndex: "2",
    position: "absolute",
    top: "75px",
    left: "1%",
    right: "1%",
    height:"auto",
    overflowX:"hidden",
    '&::-webkit-scrollbar': {
      display:"none"
    },
    [theme.breakpoints.down("md")]: {
      bottom:"3.3rem !important",
     },
     [theme.breakpoints.up("md")]: {
      bottom:"2rem !important",
     },
     [theme.breakpoints.down("sm")]:{
      top:"7.7rem"
     }
  },
  desktopRoot:{
    left:"70px"
  },

}));
export default function E_Layout() {
  let classes = useStyle();
  const dispatch = useDispatch()
  let [open,setOpen] = useState(false);
  const [loadapi,setLoadapi]=useState(false);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const isTabletOrMobile = useMediaQuery({ minWidth: 961 });
  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  // useState(()=>{
  //   //setLoadapi(true)
  //   let reload = localStorage.getItem("reload");
  //   if(!reload){
  //     localStorage.setItem('reload',true)
  //   }
  // },[])


  // const debounce = (fn, delay) => {
  //   let timeoutId;
  //   return function(...args) {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //     timeoutId = setTimeout(() => {
  //       fn(...args);
  //     }, delay);
  //   };
  // };


  // const apicall = () => {
  //   if ( window.location.pathname==routePaths.HOME) {
  //     let isAccDetailsRefreshing = localStorage.getItem("isAccDetailsRefreshing")
  //     if(!isAccDetailsRefreshing){
  //       localStorage.setItem("isAccDetailsRefreshing", true);
  //       setApiCallInProgress(true);
  //       authService.accountDetaisAfterLogin().then(accountInformation => {
  //         let bearer = JSON.parse(localStorage.getItem("bearer"));
  //         let { email, lastFourDigitsOfPhoneNumber, userName, ...accountInformationData } = accountInformation
  //         bearer.email = email
  //         bearer.lastFourDigitsOfPhoneNumber = lastFourDigitsOfPhoneNumber
  //         bearer.accountDetails = accountInformationData
  //         localStorage.setItem("bearer", JSON.stringify(bearer)
  //         );
  //         dispatch(accountsDetails())
  //         setLoadapi(false)
  //         localStorage.setItem("reload",false)
  //         localStorage.removeItem("isAccDetailsRefreshing")
  //       }).catch(accountInfoError => {
  //        console.log(accountInfoError,"Error fetching details")
  //       }).finally(() => {
  //         setApiCallInProgress(false);
  //         localStorage.removeItem("isAccDetailsRefreshing")
  //       });
  //       localStorage.removeItem("isAccDetailsRefreshing")
  //     }
  //   }
  // }


  // useEffect(()=>{
  //   document.addEventListener("visibilitychange", () => {
  //     if(!isTabletOrMobile && document.visibilityState === "visible" ){
  //       setLoadapi(true)
  //     } else {
  //       localStorage.setItem("reload",true)
  //       setLoadapi(false)
  //     }
  //   });
  // },[])

  // useEffect(()=>{
  //   let reload = localStorage.getItem("reload");
  //   if(loadapi && reload ){
  //     const debouncedApiCall = debounce(apicall, 1000);
  //     debouncedApiCall();
  //   }
  // },[loadapi])

//   useEffect(()=>{
//     apicall()
// },[])

  return (
    //  <ErrorBoundary>
    <>
   <E_SidebarController handleDrawerOpen={handleDrawerOpen} open={open}/>
      <E_Header handleDrawerOpen={handleDrawerOpen} />
      <div className={`${classes.root} ${isTabletOrMobile && classes.desktopRoot}`}
      style={{overflowY: browserName === "firefox" ? "auto" : "overlay",scrollbarWidth:browserName === "firefox" ?"none":"auto"}} >
        <Routes />
      </div>
       <E_Footer />
    </>
    // </ErrorBoundary>
  );
}
